import React from "react";
import { MessageCircle } from "lucide-react";

const ES_RX = /^(spanish|espa[ñn]ol)$/i;

export const speaksSpanish = (langs) => (langs || []).some((l) => ES_RX.test(String(l).trim()));

export const setSpanish = (langs, on) => {
  const rest = (langs || []).filter((l) => !ES_RX.test(String(l).trim()));
  return on ? [...(rest.length ? rest : ["English"]), "Spanish"] : rest.length ? rest : ["English"];
};

export function SpanishBadge({ className = "" }) {
  return (
    <span translate="no" lang="es" data-testid="badge-se-habla-espanol"
      className={`inline-flex items-center gap-1 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-0.5 text-xs font-semibold text-amber-800 ${className}`}>
      <MessageCircle className="h-3.5 w-3.5" /> Se habla español
    </span>
  );
}
